import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { message } from 'antd';
import { clearStoredAuth, getStoredToken } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://taskcenter-api.powers-ai.net/api/v2';

const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getStoredToken();
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.method && config.method.toLowerCase() === 'get') {
      config.params = { ...config.params, _t: Date.now() };
    }

    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error('API Error:', error);

    if (error.response) {
      const { status, data } = error.response;
      const responseMessage = data?.message || data?.msg || '请求失败';

      switch (status) {
        case 401: {
          const token = getStoredToken();

          if (token) {
            message.error('登录已过期，请重新登录');
          } else {
            message.error('登录状态已失效，请先登录');
            clearStoredAuth();
            if (window.location.pathname !== '/login') {
              window.location.href = '/login';
            }
          }
          break;
        }
        case 403:
          message.error('权限不足，无权访问该资源');
          break;
        case 404:
          message.error('资源不存在');
          break;
        case 500:
          message.error('服务器内部错误');
          break;
        default:
          message.error(responseMessage);
      }
    } else if (error.request) {
      message.error('网络连接失败，请检查网络设置');
    } else {
      message.error('请求配置错误');
    }

    return Promise.reject(error);
  }
);

export default apiClient;
